import { SimpleGrid } from '@chakra-ui/react';
import React from 'react';

import { AttributeInput } from 'packages/common-frontend/components/AttributeInput/AttributeInput';
import { Attribute } from 'packages/common-frontend/components/AttributeInput/types';

export const AttributesEditor = ({
  attributes,
  updateAttribute,
}: {
  attributes: Attribute[];
  updateAttribute: (updatedAttribute: Attribute) => Promise<void>;
}) => {
  return (
    <SimpleGrid
      columns={{ sm: 2, md: 4, lg: 4, xl: 4 }}
      gap="1.5rem"
      flexGrow={1}
    >
      {attributes.map((attribute) => (
        <AttributeInput
          key={attribute.attributeId}
          attribute={attribute}
          onUpdate={updateAttribute}
        />
      ))}
    </SimpleGrid>
  );
};
